if (!customElements.get('password-admin')) {
  customElements.define(
    'password-admin',
    class PasswordAdmin extends window.BAO.CustomElement() {
      constructor () {
        super()

        this.initialize()
      }

      initialize () {
        this.els.trigger.element.addEventListener(
          'click',
          this.onTriggerClick.bind(this)
        )
      }

      onTriggerClick () {
        this.els.admin.element.setAttribute(
          'aria-hidden',
          this.els.admin.element.getAttribute('aria-hidden') === 'true'
            ? 'false'
            : 'true'
        )
        this.els.newsletter.element.setAttribute(
          'aria-hidden',
          this.els.newsletter.element.getAttribute('aria-hidden') === 'true'
            ? 'false'
            : 'true'
        )

        this.els.password.element.focus()
      }
    }
  )
}
